import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ExplorePage } from './explore';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    ExplorePage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(ExplorePage),
  ],
})
export class ExplorePageModule {}



// WEBPACK FOOTER //
// ./src/pages/explore/explore.module.ts